import { EFinancingCompany, EFinancingProgram } from '@if/core/types'
import { Box, CircularProgress, Typography } from '@mui/material'
import Breadcrumb from '@src/components/Breadcrumb'
import useFeatureFlags from '@src/data/api/featureSwitch-api/featureSwitch-api'
import { useGetMerchantPaymentPlans, useMerchantById } from '@src/data/api/merchants-api/merchants-api'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import MerchantTabsForm from './components/MerchantTabsForm'

const EditMerchantPage = () => {
  const { id } = useParams()
  const [merchant, isLoading] = useMerchantById(id ?? '')
  const [parentMerchant, isLoadingParentMerchant] = useMerchantById(merchant?.parentId ?? '')
  const [merchantPaymentPlans, isPaymentPlanFetching] = useGetMerchantPaymentPlans(merchant?.id || '')
  const [featureFlags] = useFeatureFlags()

  const shouldShowGeneralTab = merchant?.financingCompanyId !== EFinancingCompany.Iceberg

  let shouldShowProgramConfigsTab: boolean
  if (featureFlags?.permitChangeFinancingProgramsSettingsForPersonalMerchant) {
    shouldShowProgramConfigsTab =
      (merchant?.supportedFinancingPrograms.includes(EFinancingProgram.B2c) ||
        merchant?.supportedFinancingPrograms.includes(EFinancingProgram.Personal)) ??
      false
  } else {
    shouldShowProgramConfigsTab = merchant?.supportedFinancingPrograms.includes(EFinancingProgram.B2c) ?? false
  }


  const { t } = useTranslation()
  const navigate = useNavigate()

  const breadCrumbs = [
    { path: '/', label: t('breadcrumbs.home') },
    {
      path: `/merchant/${merchant?.id}/view`,
      label: `${t('breadcrumbs.merchant')} : ${merchant?.name ?? ''}`,
    },
    {
      path: `/merchant/${merchant?.id}/edit`,
      label: t('breadcrumbs.edit'),
    },
  ]

  if (isLoading || isLoadingParentMerchant) {
    return (
      <Box>
        <Breadcrumb trees={breadCrumbs} />
        <CircularProgress />
      </Box>
    )
  }
  if (!merchant) {
    return <div>merchant not found</div>
  }

  if (
    merchant.financingCompanyId === EFinancingCompany.Iceberg &&
    !merchant.supportedFinancingPrograms.includes(EFinancingProgram.IfXpress)
  ) {
    navigate(`/merchant/${id}/view`, { replace: true })
  }

  return (
    <Box>
      <Breadcrumb trees={breadCrumbs} />
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h4" gutterBottom>
          {t('merchant.edit')}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {merchant.name}
        </Typography>
      </Box>
      {parentMerchant && (
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" gutterBottom>
            {t('common.banner')}
            <Typography variant="body1" color="text.secondary">
              {parentMerchant.name}
            </Typography>
          </Typography>
        </Box>
      )}
      <MerchantTabsForm
        merchant={merchant}
        shouldShowGeneralTab={shouldShowGeneralTab}
        shouldShowProgramConfigsTab={shouldShowProgramConfigsTab}
        merchantPaymentPlans={merchantPaymentPlans}
        isPaymentPlanFetching={isPaymentPlanFetching}
      />
    </Box>
  )
}

export default EditMerchantPage
